export default __webpack_public_path__ + "static/media/m9.2cea2e31.jpg";